// /expenses 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 4개를 이 배열 하나로 대체한다. field 키 / operator 는 기존과 100% 동일.

import { isCompleteDateString } from "functions/generateFilter";
import type { SearchFieldConfig } from "components/list";

export const expensesSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID에서 검색", type: "text", operator: "contains", width: 160 },
  { name: "agentName", label: "현장요원이름에서 검색", type: "text", operator: "contains", width: 200 },
  { name: "agentCode", label: "현장요원코드에서 검색", type: "text", operator: "contains", width: 200 },
  {
    name: "date",
    label: "방문일에서 검색",
    type: "date",
    operator: "eq",
    validate: isCompleteDateString,
    width: 200,
  },
];
